import React, {Component} from 'react'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

class RoomClosePopup extends Popup {
    constructor(props) {
        super(props);

        this.userClosable = false;
        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    closeRoom() {
        let chatInterface = Registry.get('chatInterface');
        let that = this;

        chatInterface.destroyVirtualRoom(
            this.props.room.roomid,
            function() {
                that.close();
            },
            function() {
                throw new Error('Close room error unhandled');
            }
        );
    }

    render() {
        let lang = Registry.get('locale');

        let {room} = this.props;

        let className = 'popup popup-close-room ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <p dangerouslySetInnerHTML={{__html:lang.close_room_confirm(room.roomid)}}></p>
                <a href="#" className="popup-button yes" onClick={() => this.closeRoom()}>{lang.yes}</a>
                <a href="#" className="popup-button no" onClick={() => this.close()}>{lang.no}</a>
            </div>
        )
    }

}

RoomClosePopup.generateKey = function(props) { return 'room-close-popup' };
RoomClosePopup.mount = function(props, onMount) { return Popup.mount(RoomClosePopup, props, onMount) };
RoomClosePopup.open = function(props) {
    var id = RoomClosePopup.generateKey(props);
    RoomClosePopup.mount(props, (r) => Popup.popups[id].open());
};

export default RoomClosePopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/RoomClosePopup/index.js